/* =============================================================================
 * M.M.LaFleur — size gate.
 *
 * Two jobs, both keyed on the same fact: has a size been chosen yet.
 *
 *   1. Publishes it onto the product form as data-mm-size-chosen="true|false".
 *      mm-pdp-space.css section 9 uses it to grey the Add to Bag button down
 *      until a size is picked; mm-sticky-atc.js uses it to decide whether its
 *      own button adds to cart or returns the shopper to the size grid.
 *
 *   2. Holds the button's label at "Add to Bag" in that waiting state, rather
 *      than letting it read as an instruction.
 *
 * WHY THE LABEL STAYS CONSTANT AND THE COLOUR CARRIES THE STATE
 * ------------------------------------------------------------
 * The theme ships this button labelled "Select a size" while disabled. That
 * makes the control describe the shopper's next chore rather than name the
 * thing it does, and it means the primary call to action on the page never says
 * what it is until the last moment.
 *
 * Naming the action and dimming it says the same thing more quietly: the button
 * is visibly not-yet-available, the size grid directly above it is the only
 * unfinished input, and the shopper works out the rest without being told. The
 * hint line under the grid still spells it out for anyone who does not.
 *
 * THE BUTTON IS STILL DISABLED. Nothing here re-enables it — mm-editorial.js
 * owns that, and it stays disabled until a variant id exists. This changes what
 * the control SAYS, never what it permits.
 *
 * PRODUCTS WITH NO SIZES MUST NOT BE GATED
 * Gift cards, and any one-size accessory, have no size grid at all. Treating
 * "no chip pressed" as "not ready" would leave those permanently greyed out.
 * No grid therefore resolves to true. This is the single most important line in
 * the file.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmSizeGateBound) return;
  window.__mmSizeGateBound = true;

  var EVENT = "mm:size-gate";
  var LABEL = "Add to Bag";

  function form() {
    return document.querySelector("[data-mm-product-form]");
  }

  function chosen() {
    var group = document.querySelector("[data-mm-size-group]");

    /* No grid on this product — nothing to choose, so it is ready to buy. */
    if (!group) return true;

    return !!group.querySelector('button[aria-pressed="true"]');
  }

  /* Only ever rewrites the theme's own "select a size" wording.
   *
   * mm-editorial.js drives this button through several states — "Add to bag",
   * "Sold out", and a transient "Added to bag" after a successful add. Matching
   * on the word "select" means this touches the one state it is meant to and
   * leaves the others exactly as the theme wrote them. Overwriting "Sold out"
   * with an invitation to buy would be actively wrong.
   */
  function relabel(f) {
    var btn = f.querySelector("[data-mm-submit]");
    if (!btn) return;

    var text = (btn.textContent || "").trim();
    if (!/select/i.test(text)) return;
    if (text === LABEL) return; /* Already ours — and stops the observer looping. */

    btn.textContent = LABEL;
  }

  function publish() {
    var f = form();
    if (!f) return;

    var isChosen = chosen();
    var value = isChosen ? "true" : "false";

    if (!isChosen) relabel(f);

    if (f.getAttribute("data-mm-size-chosen") === value) return;

    f.setAttribute("data-mm-size-chosen", value);

    /* The sticky bar lives on <body>, outside this form, and has no reason to
       observe it directly. */
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { chosen: isChosen } }));
  }

  publish();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", publish);
  }

  /* aria-pressed is set by mm-editorial.js when a chip is tapped, and the whole
     grid is re-rendered when a colourway changes — so both an attribute change
     and a subtree replacement have to land here. */
  if (window.MutationObserver) {
    new MutationObserver(publish).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-pressed"]
    });
  }
}());
